import type { components } from '@trackercop/contracts';
import { Badge } from '@/components/ui/badge';

type CrawlStatus = components['schemas']['CrawlStatus'];

const variants: Record<CrawlStatus, { variant: 'success' | 'warning' | 'info' | 'destructive' | 'muted'; label: string }> = {
  pending: { variant: 'muted', label: 'Pending' },
  running: { variant: 'info', label: 'Running' },
  completed: { variant: 'success', label: 'Completed' },
  failed: { variant: 'destructive', label: 'Failed' },
  cancelled: { variant: 'warning', label: 'Cancelled' },
};

export function CrawlStatusBadge({ status }: { status: CrawlStatus }) {
  const { variant, label } = variants[status];
  return <Badge variant={variant}>{label}</Badge>;
}
